export const TABLE_TYPE = {
  SUMMARY: 'summary',
  DETAILED: 'detailed',
  DETAILED_KENSHIN: 'kenshin',
  NOT_SELECTABLE: 'not_selectable',
};
